module.exports = __webpack_public_path__ + "static/media/01-benefit-design-premium-pass.5be50722.jpg";